import { render, staticRenderFns } from "./basic-information.vue?vue&type=template&id=098a2c6f&scoped=true&"
import script from "./basic-information.vue?vue&type=script&lang=js&"
export * from "./basic-information.vue?vue&type=script&lang=js&"
import style0 from "./basic-information.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./basic-information.vue?vue&type=style&index=1&id=098a2c6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098a2c6f",
  null
  
)

export default component.exports